import { format, subDays } from 'date-fns';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DATE_FORMAT_API } from '../../../../../../../../@constants/date';
import { FinancialAccountReportFormModel, OrderByEnum } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): FinancialAccountReportFormModel => ({
  from: format(subDays(new Date(globalSettings?.frontend_date), 1), DATE_FORMAT_API),
  to: format(subDays(new Date(globalSettings?.frontend_date), 1), DATE_FORMAT_API),
  order_by: OrderByEnum.CREATED_AT,
  with_balance: true,
  file_type: 'pdf',
  is_open: true,
});
